import React, { Component } from 'react';
import { Text, ViewBox, View } from './../common';
import styled from 'styled-components';
import { Flex, Box, Absolute } from 'rebass';
import { colors } from '../../tailwind';
import Button from '../common/FormComponents/Button';
import history from '../../core/history';
import moment from 'moment';
import { buildPhotoPath } from '../../helpers/photoutils';
import Link from '../../components/Link';
import { getp } from '../../helpers/getProp';

const layoutStyles = {
  list: {
    cardHeight: '128px',
    cardWidth: '100%',
    contentJustification: 'space-between',
    actionDirection: 'column',
    minImageSize: '200px',
    titleSize: '28px',
  },
  large: {
    cardHeight: '240px',
    cardWidth: null,
    contentDirection: 'column',
    actionDirection: 'row-reverse',
    minImageSize: '200px',
    titleSize: '28px',
  },
  small: {
    cardHeight: '200px',
    cardWidth: null,
    contentDirection: 'column',
    actionDirection: 'row',
    minImageSize: '120px',
    titleSize: '20px',
  },
};

function RemoveItem({ cancelDelete, doDelete }) {
  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      style={{ width: '100%' }}
    >
      <Box mb={4}>
        <Text title>Are you sure you want to unpublish this?</Text>
      </Box>
      <Flex>
        <Button secondary onClick={doDelete}>
          Yes
        </Button>
        <Button secondary muted ml={4} onClick={cancelDelete}>
          No
        </Button>
      </Flex>
    </Flex>
  );
}

export default class ListCard extends Component {
  state = {
    deleting: false,
    deleted: false,
  };

  deleteStart = () => {
    this.setState({
      deleting: true,
    });
  };

  cancelDelete = () => {
    this.setState({
      deleting: false,
    });
  };

  doDelete = () => {
    this.setState({
      deleting: false,
      deleted: true,
    });
    this.props.removeListing(this.props.listing.id);
  };

  render() {
    const {
      listing: {
        title,
        description,
        coverPhotoName,
        listingAddresses,
        updatedAt,
        id,
        isPublished,
      },
      layoutStyle,
    } = this.props;

    const city = getp(listingAddresses, '0.city');
    const state = getp(listingAddresses, '0.state');

    const { deleting, deleted } = this.state;

    const basePrice = this.props.listing && this.props.listing.basePrice;

    const selectedStyle = layoutStyles[layoutStyle];

    function routeTo() {
      history.push('/add-listing/' + id + '/review');
    }
    return (
      <CardViewBox
        noPadding
        style={{
          height: selectedStyle.cardHeight,
          width: selectedStyle.cardWidth,
          position: 'relative',
        }}
        noMin={layoutStyle === 'large' || layoutStyle === 'small'}
        flexDirection="row"
        flex="0 0 auto"
      >
        {deleting && (
          <RemoveItem
            cancelDelete={() => this.cancelDelete()}
            doDelete={this.doDelete}
          />
        )}
        {!deleting && (
          <React.Fragment>
            <Flex id="left" alignItems="stretch" flex={3}>
              <Link to={deleted || !isPublished ? '' : '/details/' + id}>
                <ImgBox
                  id="photo"
                  bg="green"
                  src={buildPhotoPath('x_medium', coverPhotoName)}
                  minImageSize={selectedStyle.minImageSize}
                >
                  {!isPublished && (
                    <Absolute top="16px" left="0" bg={colors.secondary} p={2}>
                      <Text white small letterSpacing=".3px">
                        Unpublished
                      </Text>
                    </Absolute>
                  )}
                </ImgBox>
              </Link>
            </Flex>
            <Flex
              id="right"
              justifyContent="space-between"
              flexDirection={selectedStyle.contentDirection}
              flex={7}
              py="22px"
              px="22px"
              style={{
                maxWidth: '66%',
              }}
            >
              <Flex
                id="LefTextCol"
                style={{ minWidth: 0 }}
                justifyContent="space-between"
              >
                <Flex
                  flexDirection="column"
                  justifyContent="space-between"
                  style={{ minWidth: 0 }}
                >
                  <Box style={{ minWidth: 0 }}>
                    <Link to={isPublished ? '/details/' + id : ''}>
                      <Text
                        fontSize={selectedStyle.titleSize}
                        primaryDark
                        lineHeight="1"
                        clickable
                        style={{ minWidth: 0 }}
                      >
                        {title}
                      </Text>
                    </Link>
                    <Text t_title bold grayDark mt="-2px">
                      ${basePrice} / day
                    </Text>
                  </Box>
                  <Text grayDark small>
                    <i className="fa fa-map-marker-alt" />{' '}
                    <Text inline grayDarkMedium ml={1}>
                      {city}, {state}
                    </Text>
                  </Text>
                </Flex>
                {!deleted && isPublished ? (
                  <DeleteBox>
                    <Text link onClick={this.deleteStart}>
                      unpublish
                    </Text>
                  </DeleteBox>
                ) : null}
              </Flex>
              <Flex id="RightTextCol">
                <Flex
                  flex={1}
                  flexDirection={selectedStyle.actionDirection}
                  justifyContent="space-between"
                  alignItems="flex-end"
                >
                  {layoutStyle !== 'small' && (
                    <Flex flexDirection="column" alignItems="flex-end">
                      <Text coolGray>Last updated</Text>
                      <Text coolGray>
                        {moment(updatedAt).format('MMMM DD, YYYY')}
                      </Text>
                    </Flex>
                  )}
                  {!deleted ? (
                    <Button
                      secondary
                      muted={isPublished}
                      style={{ width: '128px' }}
                      onClick={routeTo}
                    >
                      {isPublished ? 'Edit' : 'Continue'}
                    </Button>
                  ) : null}
                </Flex>
              </Flex>
            </Flex>
          </React.Fragment>
        )}
        <View
          if={deleted}
          className="bg-gray o-50 top-0 left-0 right-0 bottom-0 absolute f f-cc"
        >
          <View className="bg-white p-l brad-m">
            <Text>Unpublished - Refresh to update</Text>
          </View>
        </View>
      </CardViewBox>
    );
  }
}

const ImgBox = styled.div`
  background-image: ${p => `url('${p.src}')`};
  height: 100%;
  width: 100%;
  min-width: ${p => p.minImageSize};
  background-position: center;
  background-size: cover;
  position: relative;
  cursor: pointer;
`;

const CardViewBox = styled(ViewBox)``;

const DeleteBox = styled.div`
  visibility: hidden;

  ${CardViewBox}:hover & {
    visibility: visible;
  }
`;



// WEBPACK FOOTER //
// ./src/components_new/managelisting/ListCard.js